import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface ServerVaultResponse {
  success: boolean;
  paymentMethodToken?: string;
  customerId?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BraintreeService {

  /** Should console logging be active? Expected to be `false` in non-development environments. */
  protected shouldLog = !environment.production;

  /** The Braintree client token obtained inside the customerRegistration2 response */
  private _clientToken: string | undefined;

  get clientToken(): string | undefined {
    // this.shouldLog && console.debug('Getting Braintree client token value: ' + this._clientToken);
    this.shouldLog && console.debug('Getting Braintree client token value');
    return this._clientToken;
  }

  set clientToken(value: string | undefined) {
    // this.shouldLog && console.debug('Setting Braintree client token to: ' + value);
    this.shouldLog && console.debug('Setting Braintree client token value');
    this._clientToken = value;
  }

  /** The Braintree payment arrangement nonce to be submitted via customerRegistrationContinueRegistration request */
  private _nonce: string | undefined;

  get nonce(): string | undefined {
    // this.shouldLog && console.debug('Getting Braintree payment arrangement nonce value: ' + this._nonce);
    this.shouldLog && console.debug('Getting Braintree payment arrangement nonce value');
    return this._nonce;
  }

  set nonce(value: string | undefined) {
    // this.shouldLog && console.debug('Setting Braintree payment arrangement nonce value to: ' + value);
    this.shouldLog && console.debug('Setting Braintree payment arrangement nonce value');
    this._nonce = value;
  }

  /** An indicator that previous attempt to establish a Braintree payment arrangement ended in failure */
  private _paypalFailed = false;

  get paypalFailed(): boolean {
    this.shouldLog && console.debug('Getting PayPal failed value: ' + this._paypalFailed);
    return this._paypalFailed;
  }

  set paypalFailed(value: boolean) {
    this.shouldLog && console.debug('Setting PayPal failed value to: ' + value);
    this._paypalFailed = value;
  }
}
